import React from 'react';
import ReactDOM from 'react-dom';
import SitePlanMap from './SitePlanMap';

export default function SitePlan() {
  const siteplanRootNode = document.getElementById('sitemap-root');
  if (siteplanRootNode) {
    ReactDOM.render(
      <SitePlanMap element={siteplanRootNode} />,
      siteplanRootNode
    );
  }
}
